export const defaultOtherTranslations = {
  NOTIFICATION_UPDATE_SUCCESS_TITLE: 'Notification Preferences Updated',
  NOTIFICATION_UPDATE_SUCCESS_DESCRIPTION: 'Your notification settings have been updated successfully.',
  ORGANISATION_SWITCH_SUCCESSFUL_TITLE: 'Organisation Switched',
  ORGANISATION_SWITCH_SUCCESSFUL_DESCRIPTION: "You've switched to organisation {{ organisationData.name }}",
  BIOMETRIC_AUTH_ENABLED_TITLE: 'Biometric Login Enabled',
  BIOMETRIC_AUTH_ENABLED_DESCRIPTION: 'Biometric login enabled successfully',
  BIOMETRIC_AUTH_DISABLED_TITLE: 'Biometric Login Disabled',
  BIOMETRIC_AUTH_DISABLED_DESCRIPTION: 'Biometric login disabled successfully',
};
